<template>
    <div class="leftBox cockpitBox">
        <div class="cockpit_header">
            <div class="cockpit_header_bg">
                <div><img :src="require('@/assets/img/cockpit/deng.png')" alt=""></div>
                <div class="header_title">待备案项目</div>
                <div><img :src="require('@/assets/img/cockpit/dian.png')" alt=""></div>
            </div>
        </div>
        <div class="cockpit_content">
            <div class="record_num">
                <div class="record_num_box">
                    <div><span>{{projectData.nodeCount}}</span> 个</div>
                    <div>待备案节点</div>
                </div>
                <div class="record_num_box">
                    <div><span>{{projectData.count}}</span> 条</div>
                    <div>待备案条数</div>
                </div>
            </div>
            <div class="nodeDistribution cockpit_content_box">
                <div class="cockpit_content_boxHeader">
                    <div class="header_cicle"><img :src="require('@/assets/img/cockpit/cicle.png')" alt=""></div>
                    <div class="header_decrit">待备案节点分布</div>
                    <div class="header_line"></div>
                    <div class="header_sanjiao"><img :src="require('@/assets/img/cockpit/sanjiao.png')" alt=""></div>
                </div>
                <div class="cockpit_content_boxContent distribution">
                    <div id="echartsData"></div>
                </div>
            </div>
            <div class="nodeDistribution cockpit_content_box">
                <div class="cockpit_content_boxHeader">
                    <div class="header_cicle"><img :src="require('@/assets/img/cockpit/cicle.png')" alt=""></div>
                    <div class="header_decrit">待备案部门分布</div>
                    <div class="header_line"></div>
                    <div class="header_sanjiao"><img :src="require('@/assets/img/cockpit/sanjiao.png')" alt=""></div>
                </div>
                <div class="cockpit_content_boxContent distribution">
                    <div id="echartsData1"></div>
                </div>
            </div>
            <div class="tableBox" style="display: none;">
                <el-table
                    :data="tableData"
                    stripe
                    height="272"
                    style="width: 100%">
                    <el-table-column
                        prop="businessName"
                        label="项目/标段名称"
                         align="left"
                        >
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" :content="scope.row.businessName" placement="right">
                                    <div class="businessName" >
                                        {{scope.row.businessName}}
                                    </div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="flowName"
                        label="业务节点"
                        align="center"
                        width="100">
                    </el-table-column>
                    <el-table-column
                        prop="processinstancecreatedate"
                        sortable
                        width="100"
                         align="center"
                        label="提交时间">
                    </el-table-column>
                    <el-table-column
                        prop="superviseDeptName"
                        width="110"
                        label="待处理部门">
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>
<script>
import * as echarts from "echarts/core";
import { BarChart,ScatterChart,PieChart,PictorialBarChart } from 'echarts/charts';
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  DatasetComponentOption,
  TransformComponent,
  LegendComponent
} from 'echarts/components';
// 标签自动布局，全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers';
// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  BarChart,
  PieChart,
  PictorialBarChart,
  ScatterChart,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer,
  LegendComponent
]);
import vueSeamlessScroll from 'vue-seamless-scroll' 
export default {
    data(){
        return{
            projectData:{
                nodeCount:'3',
                count:'1'
            },
            tableData:[{date:'d孙菲菲'},{date:'d孙菲菲'}],
            step: 0.2, // 数值越大速度滚动越快
            limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
            hoverStop: true, // 是否开启鼠标悬停stop
            direction: 1, // 0向下 1向上 2向左 3向右
            openWatch: true, // 开启数据实时监控刷新dom
            singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
            singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
            waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
        }
    },
    components:{
        vueSeamlessScroll
    },
    mounted(){
        this.getNotFinishCount()
        this.getTableData()
    },
    methods:{
        getNotFinishCount(){
            this.$httpReq({
                url: `/cockpit/getNotFinishCount`,
                method: 'get'
            }).then(({data}) => {
                if(data.code==1){
                    this.projectData=data.data;
                    this.getEchartData(this.projectData.businessflowNodeCountVos)
                    this.getEchartData1(this.projectData.businessflowDeptCountVos)
                }
            })
        },
        getEchartData(data){
            let total=0,list=[];
            let barWidth = 5;
            for(var i in data){
                total+=data[i].count;
                list.push({name:data[i].ndoeName,value:data[i].count})
            }
            var myChart=document.getElementById("echartsData");
            myChart.style.height=((this.projectData.businessflowNodeCountVos).length)*40+'px'
            // myChart.style.height='100%';
            let yName = list.map((item) => item.name);
            let xData = list.map((item) => item.value);
            var option = {
                background:'#162949',
                xAxis: {
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        show: false
                    }
                },
                grid: {
                    containLabel: true,
                    left: '0%',
                    top: list.length > 5?'5%':'10%',
                    right: 20,
                    bottom: 0
                },
                yAxis: [{
                    inverse: true,
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        inside:true,
                        verticalAlign: 'bottom',
                        align:'top',
                        padding: [0,0,8,-5],
                        textStyle: {
                            fontSize: 12,
                            color: '#01E6FF',
                        }
                    },
                    data: yName,
                }],
                series: [
                    { //内
                        type: 'bar',
                        barWidth,
                        legendHoverLink: false,
                        symbolRepeat: true,
                        silent: true,
                        itemStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 1,
                                y2: 0,
                                colorStops: [{
                                    offset: 0,
                                    color: '#047CFF' // 0% 处的颜色
                                }, {
                                    offset: 1,
                                    color: '#00F6AE' // 100% 处的颜色
                                }]
                            }
                        },
                        data: list,
                        z: 1,
                        animationEasing: 'elasticOut'
                    },
                    { // 背景
                        type: 'pictorialBar',
                        animationDuration: 0,
                        symbolRepeat: 'fixed',
                        symbolMargin: '20%',
                        symbol: 'roundRect',
                        symbolSize: [3, barWidth],
                        itemStyle: {
                            normal: {
                                color: '#14315C',
                            }
                        },
                        label: {
                            normal: {
                                show: true,
                                position: 'right',
                                offset: [-30, -15],
                                distance: 30,
                                align:'right',
                                textStyle: {
                                    color: '#7AF8FF',
                                    fontSize: 12,
                                },
                                formatter: function(a) {
                                    return `${a.value} 条 | ${(a.value/total*100).toFixed(2)}%`
                                }
                            },

                        },
                        data: xData,
                        z: 0,
                        animationEasing: 'elasticOut'
                    },
                    { //分隔
                        type: 'pictorialBar',
                        itemStyle: {
                            color: '#000'
                        },
                        symbolRepeat: 'fixed',
                        symbolMargin: 1,
                        symbol: 'roundRect',
                        symbolClip: true,
                        symbolSize: [1, barWidth],
                        symbolPosition: 'start',
                        symbolOffset: [0, 0],
                        data: list,
                        z: 2,
                        animationEasing: 'elasticOut'
                    }
                ]
            };
            let chartBox = echarts.init(myChart);
            chartBox.setOption(option)
            window.addEventListener('resize', () => {
                chartBox.resize()
            })

        },
        getEchartData1(data){
            let total=0,list=[];
            let barWidth = 5;
            for(var i in data){
                total+=data[i].count;
                list.push({name:data[i].deptName,value:data[i].count})
            }
            var myChart1=document.getElementById("echartsData1");
            myChart1.style.height=((this.projectData.businessflowDeptCountVos).length)*40+'px'
            // myChart1.style.height='100%';
            let yName = list.map((item) => item.name);
            let xData = list.map((item) => item.value);
            var option = {
                background:'#162949',
                xAxis: {
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        show: false
                    }
                },
                grid: {
                    containLabel: true,
                    left: '0%',
                    top: list.length > 5?'5%':'10%',
                    right: 20,
                    bottom: 0
                },
                yAxis: [{
                    inverse: true,
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        inside:true,
                        verticalAlign: 'bottom',
                        align:'top',
                        padding: [0,0,8,-5],
                        textStyle: {
                            fontSize: 12,
                            color: '#01E6FF',
                        }
                    },
                    data: yName,
                }],
                series: [
                    { //内
                        type: 'bar',
                        barWidth,
                        legendHoverLink: false,
                        symbolRepeat: true,
                        silent: true,
                        itemStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 1,
                                y2: 0,
                                colorStops: [{
                                    offset: 0,
                                    color: '#047CFF' // 0% 处的颜色
                                }, {
                                    offset: 1,
                                    color: '#00F6AE' // 100% 处的颜色
                                }]
                            }
                        },
                        data: list,
                        z: 1,
                        animationEasing: 'elasticOut'
                    },
                    { // 背景
                        type: 'pictorialBar',
                        animationDuration: 0,
                        symbolRepeat: 'fixed',
                        symbolMargin: '20%',
                        symbol: 'roundRect',
                        symbolSize: [3, barWidth],
                        itemStyle: {
                            normal: {
                                color: '#14315C',
                            }
                        },
                        label: {
                            normal: {
                                show: true,
                                position: 'right',
                                offset: [-30, -15],
                                distance: 30,
                                align:'right',
                                textStyle: {
                                    color: '#7AF8FF',
                                    fontSize: 12,
                                },
                                formatter: function(a) {
                                    return `${a.value} 条 | ${(a.value/total*100).toFixed(2)}%`
                                }
                            },

                        },
                        data: xData,
                        z: 0,
                        animationEasing: 'elasticOut'
                    },
                    { //分隔
                        type: 'pictorialBar',
                        itemStyle: {
                            color: '#000'
                        },
                        symbolRepeat: 'fixed',
                        symbolMargin: 1,
                        symbol: 'roundRect',
                        symbolClip: true,
                        symbolSize: [1, barWidth],
                        symbolPosition: 'start',
                        symbolOffset: [0, 0],
                        data: list,
                        z: 2,
                        animationEasing: 'elasticOut'
                    }
                ]
            };
            let chartBox1 = echarts.init(myChart1);
            chartBox1.setOption(option)
            window.addEventListener('resize', () => {
                chartBox1.resize()
            })
        },
        getTableData(){
             this.$httpReq.post('/businessFlowWitness/list', {
                'page': 1,
                'rows': 20,
                'filter': {
                    businessType:'GC',
                }
          }).then(res => {
            this.tableData = res.data.rows;
          })
        }
    }
}
</script>
<style lang="scss" scoped>
    .leftBox{
        .record_num{
            height: 200px;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;
            margin-top: 13px;
            .record_num_box{
                width: 180px;
                height: 139px;
                background: url('../../../../../assets/img/cockpit/record/record.png');
                text-align: center;
                padding-top: 37px;
                &:nth-of-type(1){
                    margin-right: 44px;
                }
                &>div:nth-of-type(1){
                    color: #ffffff;
                    span{
                        font-size: 28px;
                        font-family: DIN-Bold, DIN;
                        font-weight: bold;
                        height: 34px;
                        // width: 33px;
                        display: inline-block;
                    }
                }
                &>div:nth-of-type(2){
                    color: #66FFFF;
                    line-height: 16px;
                    height: 18px;
                    font-size: 14px;
                    margin-top: 5px;
                }
            }
        }
        .nodeDistribution{
            .distribution{
                // height: 200px;
                height: 300px;
                overflow: auto;
                margin: 10px 0;
            }
            /deep/ .distribution::-webkit-scrollbar {
                width:7px;
                background-color: transparent;
            }
            /* 滚动槽 */
            /deep/ .distribution::-webkit-scrollbar-track {
                -webkit-box-shadow:inset 2px rgba(0,0,0,0.3);
                background: #16335a;
            }
            /* 滚动条滑块 */
            /deep/ .distribution::-webkit-scrollbar-thumb {
                background:#162b4b;
            }
            #echartsData,#echartsData1{
                width: 480px;
                min-height: 100px;
                // margin: -10px 0 0 30px;
                margin: 0px 0 0 30px;

            }
        }
        .tableBox{
            height: 272px;
            margin:10px 12px 0px 12px;
            overflow: auto;
            .businessName{
                overflow:hidden;
                text-overflow:ellipsis;
                display:-webkit-box;
                -webkit-box-orient:vertical;
                -webkit-line-clamp:2; 
                text-align: left;
            }
        }
        /deep/ .el-table__body-wrapper::-webkit-scrollbar {
            width:7px;
            background-color: transparent;
        }
        /* 滚动槽 */
        /deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
            -webkit-box-shadow:inset 2px rgba(0,0,0,0.3);
            background: #16335a;
        }
        /* 滚动条滑块 */
        /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
            background:#162b4b;
        }
    }
</style>